import React, { useState } from "react";
import moment from "moment";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

const DATE_FORMAT = "MM/DD/YYYY";

export default function EditableDateRangeFilter({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  spacing = 1,
  mb = 2,
}) {
  const [openStartDate, setOpenStartDate] = useState(false);
  const [openEndDate, setOpenEndDate] = useState(false);

  const startDateMoment = startDate ? moment(startDate, DATE_FORMAT) : null;
  const endDateMoment = endDate ? moment(endDate, DATE_FORMAT) : null;

  const handleStartDateChange = newDate => {
    const formattedDate = newDate ? moment(newDate).format(DATE_FORMAT) : null;
    onStartDateChange(formattedDate);
    if (newDate && moment(newDate).isValid()) {
      setOpenEndDate(true);
    }
  };

  const handleEndDateChange = newDate => {
    const formattedDate = newDate ? moment(newDate).format(DATE_FORMAT) : null;
    onEndDateChange(formattedDate);
  };

  return (
    <Box mb={mb}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Grid container spacing={spacing}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <DesktopDatePicker
              open={openStartDate}
              onOpen={() => setOpenStartDate(true)}
              onClose={() => setOpenStartDate(false)}
              label="Start Date"
              value={startDateMoment}
              onChange={handleStartDateChange}
              format={DATE_FORMAT}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: "small",
                  autoComplete: "off",
                  onClick: () => setOpenStartDate(true),
                  variant: "outlined",
                },
              }}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <DesktopDatePicker
              open={openEndDate}
              onOpen={() => setOpenEndDate(true)}
              onClose={() => setOpenEndDate(false)}
              label="End Date"
              value={endDateMoment}
              referenceDate={startDateMoment}
              onChange={handleEndDateChange}
              minDate={startDateMoment}
              format={DATE_FORMAT}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: "small",
                  autoComplete: "off",
                  onClick: () => setOpenEndDate(true),
                  variant: "outlined",
                },
              }}
            />
          </Grid>
        </Grid>
      </LocalizationProvider>
    </Box>
  );
}
